import {
  AppBar,
  Box,
  Button,
  Checkbox,
  Container,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Select,
  TextField,
  Toolbar,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import React, { useState } from "react";
import useStyles from "./style";
import PesquisaCredito from "../../pages/PesquisaCredito";
import jsondata from "../../test/mock/dinamicComponent";
import MenuIcon from "@mui/icons-material/Menu";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import UsuarioService from "../../services/usuarioService";
import { toast } from "react-toastify";
const ModalUsuarios = (props) => {
  const classes = useStyles();
  const params = useParams();

  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [cargo, setCargo] = useState("");
  const [telefone, setTelefone] = useState("");
  const [perfil, setPerfil] = useState("");
  const [empresa, setEmpresa] = useState("");
  const [checked, setChecked] = useState(false);
  const [checkedTemporario, setCheckedTemporario] = useState(false);

  const [emailMaskError, setEmailMaskError] = useState({ isError: false, erroMsg: "" });
  const [nomeError, setNomeError] = useState({ isError: false, erroMsg: "" });
  const [perfilError, setPerfilError] = useState({ isError: false, erroMsg: "" });

  const changeStatus = () => {
    setChecked(!checked);
  };

  const changeStatusTemporario = () => {
    setCheckedTemporario(!checkedTemporario);
  };

  useEffect(async () => {
    if (props.empresa) {
      setEmpresa(props.empresa);
    }
    if (props.user) {
      let user = props.user;
      setNome(user.nome);
      setEmail(user.username);
      setCargo(user.cargo || "");
      setPerfil(user.perfil.id);
      setChecked(user.ind_ativo);
      setTelefone(user.telefone || "")
    }
  }, []);


  const resetFields = () => {
    setEmailMaskError({ isError: false });
    setNomeError({ isError: false });
    setPerfilError({ isError: false, erroMsg: "" });
  }


  const validateFields = () => {
    resetFields();

    let isError = false;

    if (emailMaskError.isError || email == "") {
      checkEmailMask(email)
      isError = true;
    }
    
    if (nome == "" || nome.length < 2) {
      setNomeError({isError:true, erroMsg: "Digite um nome válido" })
      isError = true;
    } 

    if (perfil == "") {
      setPerfilError({isError:true, erroMsg: "Escolha um perfil válido" })
      isError = true;
    }

    if (isError)
      return false;

    return true;
  }


  const saveUser = async () => {
    if (validateFields()) {
      let user = {
        username: email,
        nome: nome,
        cargo: cargo,
        telefone: telefone,
        empresa: {
          id: parseInt(props.empresaId),
        },
        perfil: {
          id: perfil,
        },
      };
      if (props.id) {
        user["id"] = props.id;
        user["ind_ativo"] = checked;
        const response = await UsuarioService.editarUsuario(user).then(() => {
          toast.success("Usuário Atualizado com Sucesso!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          props.fecharModal();
          props.buscarUsuarios(params.id, '', 1);
        }).catch((e) => {
          toast.error(e.detail, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        });
      } else {
        user["ind_temporario"] = checkedTemporario;
        const response = await UsuarioService.cadastrarUsuario(user).then(() => {
          toast.success("Usuário Cadastrado com Sucesso!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          props.fecharModal();
          props.buscarUsuarios(params.id, '', 1);
        }).catch((e) => {
          toast.error(e.detail, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        });
      }
    }
  };

  const checkEmailMask = (email) => {
    setEmail(email);
    if (/.+@.+\.[A-Za-z]+$/.test(email)) {
      setEmailMaskError({ isError: false });
    } else {
      setEmailMaskError({ isError: true, erroMsg: "Digite um email válido" });
    }
  };
  

  return (
    <Paper className={classes.card}>
      <div>
        <Box sx={{ flexGrow: 1 }}>
          <AppBar
            position="static"
            color="default"
            style={{ borderRadius: "1rem 1rem 0 0" }}
          >
            <Container>
              <Toolbar>
                <Typography
                  variant="h6"
                  color="inherit"
                  className={classes.grow}
                  style={{ flex: 1 }}
                >
                  Cadastro de Usuário
                </Typography>
                <IconButton onClick={props.fecharModal} aria-label="info">
                  <CloseIcon style={{ width: "32px", marginBottom: "1px" }} />
                </IconButton>
              </Toolbar>
            </Container>
          </AppBar>
        </Box>
        <Grid className={`${classes.root} ${classes.scroll}`}>
          <Container>
            <Box component={"div"} my={8}>
              <Grid
                container
                item
                justifyContent="flex-start"
                alignItems="center"
                md={7}
                xs={12}
              ></Grid>
              {/* <h2>teste</h2>
              username: str nome: str cargo: Optional[str] telefone:
              Optional[str] ind_temporario: bool empresa: EmpresaList perfil:
              Perfil */}
              <Grid container className={classes.margin}>
                <Grid item xs={12}>
                  <Grid container spacing={3} alignItems="baseline">
                    <Grid item xs={12}>
                      <div className={classes.margin}>
                        <TextField
                          error={emailMaskError.isError}
                          helperText={emailMaskError.erroMsg}
                          size="small"
                          label="Email"
                          variant="outlined"
                          type="text"
                          fullWidth={true}
                          value={email}
                          onChange={(e) => checkEmailMask(e.target.value)}
                        />
                      </div>
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        error={nomeError.isError}
                        size="small"
                        label="Nome"
                        variant="outlined"
                        type="text"
                        fullWidth={true}
                        helperText={nomeError.erroMsg}
                        value={nome}
                        onChange={(e) => setNome(e.target.value)}
                      />
                    </Grid>

                    <Grid item md={6} xs={12}>
                      <TextField
                        disabled
                        // error={error.isError}
                        size="small"
                        label="Empresa"
                        variant="outlined"
                        type="text"
                        fullWidth={true}
                        // helperText={error.erroMsg}
                        value={empresa}
                      />
                    </Grid>

                    <Grid item md={6} xs={12}>
                      <TextField
                        // error={error.isError}
                        size="small"
                        label="Cargo"
                        variant="outlined"
                        type="text"
                        fullWidth={true}
                        value={cargo}
                        onChange={(e) => setCargo(e.target.value)}
                      />
                    </Grid>

                    <Grid item md={6} xs={12}>
                      <TextField
                        size="small"
                        label="Telefone"
                        variant="outlined"
                        type="text"
                        fullWidth={true}
                        value={telefone}
                        onChange={(e) => setTelefone(e.target.value)}
                      />
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <FormControl variant="outlined" size="small" fullWidth error={perfilError.isError}>
                        <Select
                          error={perfilError.isError}
                          size="small"
                          variant="outlined"
                          value={perfil}
                          onChange={(e) => setPerfil(e.target.value)}
                          name="perfil"
                          displayEmpty
                          className={classes.selectEmpty}
                        >
                          <MenuItem value="">Perfil</MenuItem>
                          <MenuItem value={1}>ADMIN-NEOCREDIT</MenuItem>
                          <MenuItem value={2}>NORMAL</MenuItem>
                        </Select>
                        <FormHelperText>{perfilError.erroMsg}</FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item md={6} xs={12}>
                      {props.id != undefined && (
                        <FormControl variant="outlined" size="small" fullWidth>
                          <Grid item md={6} xs={12}>
                            Ativo
                            <Checkbox
                              checked={checked}
                              onChange={changeStatus}
                              name="setChecked"
                              value={checked}
                            />
                          </Grid>
                        </FormControl>
                      )}
                      {props.id == undefined && (
                        <FormControl variant="outlined" size="small" fullWidth>
                          <Grid item md={6} xs={12}>
                            Temporario
                            <Checkbox
                              checked={checkedTemporario}
                              onChange={changeStatusTemporario}
                              name="setCheckedTemporario"
                              value={checkedTemporario}
                            />
                          </Grid>
                        </FormControl>
                      )}
                    </Grid>
                  </Grid>
                  <Box marginTop="2rem" width="80rem" maxWidth="95vw">
                    {props.id != undefined ? (
                      <Button
                        onClick={saveUser}
                        type="submit"
                        variant="contained"
                        color="primary"
                      >
                        Atualizar
                      </Button>
                    ) : (
                      <Button
                        onClick={saveUser}
                        type="submit"
                        variant="contained"
                        color="primary"
                      >
                        Salvar
                      </Button>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Container>
        </Grid>
      </div>
    </Paper>
  );
};

export default ModalUsuarios;
